import { render, staticRenderFns } from "./UserOverviewGeneral.vue?vue&type=template&id=e94a5a46&scoped=true&"
import script from "./UserOverviewGeneral.vue?vue&type=script&lang=js&"
export * from "./UserOverviewGeneral.vue?vue&type=script&lang=js&"
import style0 from "./UserOverviewGeneral.vue?vue&type=style&index=0&id=e94a5a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94a5a46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCol,VDialog,VIcon,VListItemContent,VListItemTitle,VRow,VSelect})
